import { Button } from 'components/button';
import Icon from 'components/icon/Icon';
import usePostMessage from 'hooks/utils/usePostMessage';

function DownloadFileButton({ item }) {
  const { sendMessage } = usePostMessage();

  function handleClick() {
    const data = {
      document: 'pdf',
      link: item.signedDownloadUrl,
      fileName: item.filename,
      description: '',
      canGoBack: false
    };

    sendMessage({ message: data });
  }

  return (
    <Button
      className="c-button c-button--tiny u-margin-right-medium"
      onClick={() => handleClick()}
    >
      <Icon id={'download'} strokeColor="color-neutral-dark" />
    </Button>
  );
}

export default DownloadFileButton;
